import axios from "axios";

const fetchData = async (resourse_url: string, filters: string = '') => {

    const baseUrl = `${resourse_url}?${filters}`
    let currentPage = 1;
    let allData: any = [];

    try {
      while (true) {
        const response = await axios.get(`${baseUrl}&page=${currentPage}`);
        const newData = response.data; // Assuming the API response format contains the data you need

        if (!newData?.results) {
          // No data found
          break;
        }

        allData = [...allData, ...newData.results];
        currentPage++;

        if (!newData?.next && !newData?.links?.next) {
          // No more data after this one
          break;
        }
      }

      return allData;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };

export default fetchData;